import React, {useCallback, useMemo} from 'react';
import {Alert, Stack} from 'react-bootstrap';
import {useFormikContext} from 'formik';
import styled from 'styled-components';
import {ControlButton} from 'components/customer/Product/Appliance/AddApplianceForm';
import {Appliance} from 'components/customer/Product/Appliance/entity/Appliance';

interface CustomApplianceDetailsProps {
    onEditClick?: (check?: boolean) => void;
}

export const CustomApplianceDetails = ({
    onEditClick,
}: CustomApplianceDetailsProps) => {
    const {values} = useFormikContext<{appliance: Appliance}>();
    const appliance = values.appliance;

    const editClickHandler = useCallback(() => {
        onEditClick && onEditClick(false);
    }, [onEditClick]);

    const {fileName, url} = useMemo(() => {
        let fileName: string | null = null;
        let url: string | null = null;

        if (appliance) {
            if (typeof appliance.specPath === 'string') {
                if (appliance.specPath.includes('/')) {
                    const parts = appliance.specPath.split('/');

                    fileName = parts.pop() ?? null;
                } else {
                    fileName = appliance.specPath;
                }

                url = appliance.specPath;

                if (url.indexOf('/') > 0) {
                    url = `/${url}`;
                }
            }

            if (appliance.specPath instanceof File) {
                fileName = appliance.specPath.name;
                url = URL.createObjectURL(appliance.specPath);
            }
        }

        return {
            fileName,
            url,
        };
    }, [appliance]);

    if (appliance == undefined || !appliance.custom) {
        return null;
    }

    return (
        <>
            <Stack
                direction="horizontal"
                className="justify-content-between align-items-center mt-2 mb-2 gap-2">
                <Stack gap={2}>
                    <ApplianceName>
                        {appliance.make} {appliance.model}
                    </ApplianceName>
                    {appliance.specPath ? (
                        <FileName
                            href={url || ''}
                            target="_blank"
                            title="Download file">
                            {fileName}
                        </FileName>
                    ) : null}
                </Stack>

                <Button
                    variant="primary"
                    type="button"
                    onClick={editClickHandler}>
                    Edit
                </Button>
            </Stack>

            <Alert variant="warning" className="mt-3 mb-0 align-items-start">
                <strong>WARNING&nbsp;:</strong>&nbsp;Custom rangehoods may
                increase costs or delay processing of your job.
            </Alert>
        </>
    );
};

const Button = styled(ControlButton)`
    background: ${({theme}) => theme.colors.secondary?.main};

    &:hover {
        background: ${({theme}) => theme.colors.primary?.main};
    }
`;

const ApplianceName = styled.span`
    font-weight: 600;
`;

const FileName = styled.a`
    color: #6c757d;
    font-size: 0.85rem;
    word-break: break-word;
`;
